<template>
  <div id="app" v-if="!_isMobile()">
    <component :is="Header" v-if="!isIndexPage && isShowMain && !isH5()" />
    <component
      :is="BannerIndex"
      v-if="isIndexPage && isShowMain && !isH5()"
      :navData="navData"
    />
    <component
      :is="BannerCommon"
      v-else-if="
        showBanner && isShowMain && hideBanner && padHideBanner && !isH5()
      "
    />
    <!-- <NavMenu :list="navData"/> -->
    <a-config-provider :locale="locale">
      <div
        :class="{
          'main-container-pad': machineType == 'pad',
          'main-container': machineType == 'pc',
        }"
      >
        <router-view />
      </div>
    </a-config-provider>
    <component :is="Footer" v-if="isShowMain && hideBanner && !isH5()" />
    <!-- 通知中心 -->
    <NotificationCenter
      :notifications="notifications"
      :on-click="handleNotificationClick"
      @remove-notification="removeNotification"
    />
    <div>
      <ModalComponent
        :visible="modalVisible"
        :title="modalTitle"
        :button-text="openButtonText"
        :ok-text="confirmButtonText"
        :cancel-text="cancelButtonText"
        :handle-ok="handleConfirm"
        :handle-cancel="handleCancel"
        :handle-close="handleClose"
        :buttonAlign="buttonAlign"
      >
        <div class="modal-content">
          <h1 style="text-align: center">恭喜您晋级决赛!</h1>
          <p style="font-size: 18px">
            根据大赛公告，我们将于2025年9月6日至9月9日在中国福建省厦门市举办决赛和颁奖对接活动，敬请您拨冗参赛，我们将做好相关服务保障。
          </p>
        </div>
      </ModalComponent>
    </div>
  </div>
</template>

<script>
// import Header from '@/components/header'
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import NotificationCenter from "@/components/notification/NotificationCenter.vue";
import ModalComponent from "@/components/modal/index.vue";
import { getMessageList, updateReadState } from "@/api/message-list";
import { changeIsParticipate } from "@/api/declaration";
import { Modal } from "ant-design-vue";
import { mapGetters } from "vuex";
import { getUnitInfo } from "@/api/userInfo";
// import Header from '@/components/header'
// import BannerIndex from '@/components/banner-index'
// import BannerCommon from '@/components/banner-common'
// import NavMenu from '@/components/nav-menu'
// import Footer from '@/components/footer'
// import Container from './container'

export default {
  name: "App",
  components: {
    NotificationCenter,
    ModalComponent,
    // Header,
    // BannerIndex,
    // BannerCommon,
    // NavMenu,
    // Footer,
    // Container
  },
  data() {
    return {
      locale: zhCN,
      Header: () => import("@/components/header"),
      BannerIndex: () => import("@/components/banner-index"),
      BannerCommon: () => import("@/components/banner-common"),
      Footer: () => import("@/components/footer"),
      machineType: "",
      padHideBanner: true,

      notifications: [],
      pollInterval: null,
      // 配置参数
      pollIntervalTime: 30000, // 轮询间隔，30秒
      maxNotifications: 5, // 最大显示通知数量
      modalVisible: false,
      modalTitle: "海外创赛",
      openButtonText: "打开模态框",
      confirmButtonText: "我参加现场路决赛",
      cancelButtonText: "我放弃参赛",
      buttonAlign: "center",
      declarationId: null,
      removeNotificationId: null,
      isShow: false,
    };
  },
  computed: {
    ...mapGetters(["loginType"]),
    // 优培生选拔
    isShowMain() {
      const { path } = this.$route;
      return ![
        "/login",
        "/login-online-review",
        "/guide",
        "/test",
        "/abroadLogin",
        "/abroadlogin",
      ].includes(path);
    },
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
    isIndexPage() {
      return ["/", "/institution/index", "/personal/index"].includes(
        this.$route.path,
      );
    },
    showBanner() {
      return ![
        "/personal/declare-list",
        "/personal/declare-list/declare-apply",
      ].includes(this.$route.path);
    },
    navData() {
      const path = this.$route.path;
      if (["/", "/institution/", "/institution/index"].includes(path)) {
        if (this.loginType == 3) {
          return [
            {
              name: "双百计划",
              url: "/institution/dh-review/innovation-list",
            },
            {
              name: "拔尖人才",
              url: "/institution/bajian-review-list",
            },
            {
              name: "生物医药",
              url: "/institution/biology-medicine-list",
            },
            {
              name: "商贸物流人才",
              url: "/institution/commerce-review-list",
            },
            {
              name: "金融服务产业人才",
              url: "/institution/financial-review-list",
            },
            {
              name: "骨干人才",
              url: "/institution/backbone-review-list",
            },
            {
              name: "社会工作人才",
              url: "/institution/social-review-list",
            },
            {
              name: "海洋人才",
              url: "/institution/ocean-review-list",
            },
            {
              name: "教育人才",
              url: "/institution/education-review-list",
            },
            {
              name: "文旅创意人才",
              url: this.isShow
                ? "/institution/culturalTourism-review-manager-list"
                : "/institution/culturalTourism-review-list",
            },
            {
              name: "卫生健康人才",
              url: "/institution/sanitationHealth-review-list",
            },
          ];
        } else if (this.loginType == 5) {
          return [
            {
              name: "双百计划",
              url: "/institution/dh-review/innovation-list",
            },
            {
              name: "拔尖人才",
              url: "/institution/bajian-review-list",
            },
            {
              name: "生物医药",
              url: "/institution/biology-medicine-list",
            },
            {
              name: "商贸物流人才",
              url: "/institution/commerce-review-list",
            },
            {
              name: "金融服务产业人才",
              url: "/institution/financial-review-list",
            },
            {
              name: "骨干人才",
              url: "/institution/backbone-review-list",
            },
            {
              name: "社会工作人才",
              url: "/institution/social-review-list",
            },
            {
              name: "海洋人才",
              url: "/institution/ocean-review-list",
            },
            {
              name: "教育人才",
              url: "/institution/education-review-list",
            },
            {
              name: "文旅创意人才",
              url: this.isShow
                ? "/institution/culturalTourism-review-manager-list"
                : "/institution/culturalTourism-review-list",
            },
            {
              name: "卫生健康人才",
              url: "/institution/sanitationHealth-review-list",
            },
          ];
        } else {
          return [
            {
              name: "优培生",
              url: "/institution/post-list",
            },
            {
              name: "双百计划",
              url: "/institution/dh-review/innovation-list",
            },
            {
              name: "拔尖人才",
              url: "/institution/bajian-review-list",
            },
            {
              name: "生物医药产业人才",
              url: "/institution/biology-medicine-list",
            },
            {
              name: "商贸物流产业人才",
              url: "/institution/commerce-review-list",
            },
            {
              name: "金融服务产业人才",
              url: "/institution/financial-review-list",
            },
            {
              name: "重点产业骨干人才",
              url: "/institution/backbone-review-list",
            },
            {
              name: "社会工作人才",
              url: "/institution/social-review-list",
            },
            {
              name: "海洋经济人才",
              url: "/institution/ocean-review-list",
            },
            {
              name: "教育人才",
              url: "/institution/education-review-list",
            },
            {
              name: "文旅创意产业人才",
              url: this.isShow
                ? "/institution/culturalTourism-review-manager-list"
                : "/institution/culturalTourism-review-list",
            },
            {
              name: "卫生健康人才",
              url: "/institution/sanitationHealth-review-list",
            },
          ];
        }
      } else if ("/personal/index" === path) {
        return [
          {
            name: "项目公告",
            url: "/personal/plan-publicity",
          },
          {
            name: "申报大厅",
            url: "/personal/declare-list",
          },
        ];
      }
      return [];
    },
    // 双百计划
    // 拔尖人才的设置成隐藏
    hideBanner() {
      return (
        !this.$route.path.includes("/start-apply-personal") &&
        !this.$route.path.includes("/bajian")
      );
    },
  },
  methods: {
    _isMobile() {
      const device = navigator.userAgent;
      if (!device.includes("HarmonyOS")) {
        return navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|MicroMessenger)/i,
        );
      }
    },
    isH5() {
      return this.$route.path.startsWith("/mobile"); // 判断是否是H5页面
    },
    //模态框开始
    // 确定按钮的逻辑
    handleConfirm() {
      //修改状态为参加决赛
      const that = this;
      changeIsParticipate({
        declarationId: this.declarationId,
        isparticipate: 0,
      }).then((res) => {
        if (res?.code == 0) {
          that.removeNotification(that.removeNotificationId);
          this.$router.push("/personal/user-info?currentPage=2&code=overseas");
        } else {
          this.$message.info(res?.msg || "操作失败");
        }
      });
      this.modalVisible = false; // 关闭模态框
    },
    handleClose() {
      this.modalVisible = false; // 关闭模态框
    },
    // 取消按钮的逻辑
    handleCancel() {
      const that = this;
      Modal.confirm({
        title: "确认框",
        content: "您确定放弃参赛?",
        okText: "是",
        cancelText: "否",
        class: "force-swap-modal",
        // 确认按钮回调
        onOk() {
          // 这里可以添加确认后的业务逻辑
          return new Promise((resolve) => {
            // 调用API
            changeIsParticipate({
              declarationId: that.declarationId,
              isparticipate: 1,
            }).then((res) => {
              if (res?.code === 0) {
                // 接口调用成功
                that.removeNotification(that.removeNotificationId);
                that.$message.success("弃赛成功");
              } else {
                // 接口调用失败
                that.$message.info(res?.msg || "操作失败");
              }
              that.modalVisible = false;
              resolve(); // 无论成功失败，都关闭确认框
            });
          });
        },
        // 取消按钮回调
        onCancel() {
          console.log("用户点击了取消");
          // 这里可以添加取消后的业务逻辑
        },
      });
      //this.modalVisible = false; // 关闭模态框
    },
    //模态框结束

    //通知中心开始
    /**
     * 开始定时轮询
     */
    startPolling() {
      if (this.pollInterval) {
        this.stopPolling();
      }

      this.pollInterval = setInterval(() => {
        this.fetchNotifications();
      }, this.pollIntervalTime);
    },

    /**
     * 停止定时轮询
     */
    stopPolling() {
      if (this.pollInterval) {
        clearInterval(this.pollInterval);
        this.pollInterval = null;
      }
    },

    /**
     * 从后端获取消息通知
     */
    async fetchNotifications() {
      console.log("进入fetchNotifications:" + !this.$store.getters.token);
      if (!this.$store.getters.token) {
        return false;
      }
      console.log("开始fetchNotifications");
      try {
        const pageParams = {
          pageNum: 1,
          pageSize: 1,
          isRead: 0,
        };
        getMessageList(pageParams)
          .then((result) => {
            result.data.forEach((notification) => {
              if (!this.displayedNotificationIds.includes(notification.id)) {
                // 将新消息ID添加到缓存
                this.addNotification({
                  id: notification.id,
                  title: notification.title || "系统通知",
                  message: notification.content.substring(0, 20) + "...",
                  type: notification.type || "info",
                  timestamp: notification.createTime,
                  // 开始修改：添加跳转相关字段
                  url: notification.openUrl, // 跳转链接
                  isRouterLink: notification.isRouterLink || false, // 是否为路由链接
                  target: notification.target || "_self", // 链接打开方式
                  // 结束修改：添加跳转相关字段
                });
                this.addToCache(notification.id);
              }
            });
          })
          .catch((error) => {
            console.error(error);
          });
      } catch (error) {
        console.error("获取通知失败:", error);
      }
    },

    /**
     * 添加新通知
     */
    addNotification(notification) {
      this.notifications.unshift(notification);

      // 限制最大通知数量
      if (this.notifications.length > this.maxNotifications) {
        this.notifications.pop();
      }
    },

    /**
     * 移除通知
     */
    removeNotification(id) {
      updateReadState([id])
        .then(() => {
          this.notifications = this.notifications.filter(
            (notification) => notification.id !== id,
          );
        })
        .catch(() => {
          this.$message.error("更新失败");
        })
        .finally(() => {
          this.$store.dispatch("updateMessageCount");
        });
    },

    //通知中心结束

    // 开始修改：缓存相关方法
    /**
     * 添加ID到缓存
     * @param {string|number} id - 消息ID
     */
    addToCache(id) {
      // 先移除可能存在的旧ID（如果有的话）
      this.displayedNotificationIds = this.displayedNotificationIds.filter(
        (cacheId) => cacheId !== id,
      );

      // 添加新ID到缓存
      this.displayedNotificationIds.unshift(id);

      // 限制缓存大小
      if (this.displayedNotificationIds.length > this.maxCacheSize) {
        this.displayedNotificationIds.pop();
      }
    },

    /**
     * 保存缓存到本地存储
     */
    saveCacheToStorage() {
      try {
        localStorage.setItem(
          "notificationCache",
          JSON.stringify(this.displayedNotificationIds),
        );
      } catch (e) {
        console.error("保存通知缓存失败:", e);
      }
    },

    /**
     * 从本地存储加载缓存
     */
    loadCacheFromStorage() {
      // try {
      //   const cached = localStorage.getItem("notificationCache");
      //   console.log("本地缓存" + cached);
      //   if (cached) {
      //     this.displayedNotificationIds = JSON.parse(cached);
      //   }
      // } catch (e) {
      //   console.error("加载通知缓存失败:", e);
      //   // 加载失败时初始化空缓存
      //   this.displayedNotificationIds = [];
      // }
      this.displayedNotificationIds = [];
    },
    // 结束修改：缓存相关方法
    handleNotificationClick(notification) {
      const url = notification.url;
      if (url && url.indexOf("海外创赛") > -1) {
        this.declarationId = url.replace("海外创赛", "");
        this.removeNotificationId = notification.id;
        this.modalVisible = true;
      }
    },
  },
  created() {
    console.log(this.$route.path, "this.$route.path.includes('institution')");
    if (["/institution/", "/institution/index"].includes(this.$route.path)) {
      getUnitInfo().then((res) => {
        if (
          res.data.creditCode == "1235020076929882XD" ||
          res.data.creditCode == "123502004266038886"
        ) {
          this.isShow = true;
        }
      });
    }
    // 检测是否为移动端
    if (this._isMobile() && !this.isH5()) {
      // 覆写alert方法
      window.alert = function (name) {
        const iframe = document.createElement("IFRAME");
        iframe.style.display = "none";
        iframe.setAttribute("src", "data:text/plain,");
        document.documentElement.appendChild(iframe);
        window.frames[0].window.alert(name);
        iframe.parentNode.removeChild(iframe);
      };
      alert("请使用电脑端申报");
      window.history.go(-1);
    } else {
      const webpageVisibleH2 =
        document.documentElement.offsetHeight || document.body.offsetHeight;
      const webpageVisibleW2 =
        document.documentElement.offsetWidth || document.body.offsetWidth;
      if (webpageVisibleH2 >= webpageVisibleW2) {
        this.machineType = "pad";
      } else {
        this.machineType = "pc";
      }
    }
    const device = navigator.userAgent;
    if (device.includes("HarmonyOS")) {
      let that = this;
      // 监听窗口尺寸变化的事件
      window.addEventListener("resize", function () {
        // 获取当前窗口的宽度和高度
        var width = window.innerWidth;
        var height = window.innerHeight;

        // 根据宽度和高度判断横屏还是竖屏
        if (width > height) {
          // 横屏逻辑
          // alert('横屏');
          that.padHideBanner = false;
          // 在这里触发你的横屏逻辑
        } else {
          // 竖屏逻辑
          // alert('竖屏');
          that.padHideBanner = true;
          // 在这里触发你的竖屏逻辑
        }
      });

      // 页面加载时也要进行一次初始检测
      window.addEventListener("load", function () {
        var width = window.innerWidth;
        var height = window.innerHeight;

        if (width > height) {
          // alert('初始加载为横屏',this);
          that.padHideBanner = false;
          // 在加载时如果是横屏，可以触发横屏逻辑
        } else {
          // alert('初始加载为竖屏');
          that.padHideBanner = true;
          // 在加载时如果是竖屏，可以触发竖屏逻辑
        }
      });
    }

    //通知中心开始
    // 初始化时获取一次消息
    this.fetchNotifications();

    // 设置定时轮询
    this.startPolling();
    // 开始修改：从本地存储恢复缓存（可选）
    this.loadCacheFromStorage();
    // 结束修改：从本地存储恢复缓存（可选）
    //通知中心结束
  },
  beforeDestroy() {
    // 清除轮询
    this.stopPolling();

    // 开始修改：保存缓存到本地存储（可选）
    this.saveCacheToStorage();
    // 结束修改：保存缓存到本地存储（可选）
  },
};
</script>
<style lang="less" scoped>
.main-container {
  margin: auto;
  // min-width: 1340px;
  min-width: 100%;
  min-height: calc(100vh - 509px);
}

.main-container-pad {
  margin: auto;
  // min-width: 1340px;
  min-width: 100%;
  min-height: calc(100vh - 200px);
  // background-color: #f5f5f5
}
</style>
